export default {
  inserted(el, binding) {
    const observer = new IntersectionObserver(
      (entries) => {
        const flag = entries[0].isIntersecting;
        if (flag) {
          binding.value(true);
          observer.unobserve(el);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.5,
      }
    );

    observer.observe(el);
  },
};
